import { gql } from '@apollo/client';

export const TOGGLE_REACTION = gql`
    mutation toggleReaction($input: ReactionInput!) {
        toggleReaction(input: $input) {
            collectionName
            docId
            reactionState {
                isAlreadyLike
                isAlreadyDislike
            }
            reactionNumber {
                totalLike
                totalDislike
            }
        }
    }
`;
